import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { Redirect } from 'react-router-dom';

import { LuPlus } from "react-icons/lu";

import Departments from "../pages/Departments";
import RiskLevels from "../pages/RiskLevels";

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';



import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";


import AdminOverlay from "../components/Admin/AdminOverlay";

import AdminTable from "../components/Admin/AdminTable";



import { getUsers, createUser, updateUser, resetEditUserOverlay, resetAdminError } from "../store/actions/adminActions";

function Users(props) {

    const { token, users, getUsersFN, createUserFN, updateUserFN, resetEditUserOverlayFN, edit_user_overlay, error_message, resetAdminErrorFN, created, departments } = props;




    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [editinguser, setEditingUser] = useState(null);

    const [currPage, setcurrPage] = useState("users");





    const openpopup = (data) => {
        ////console.log(data)
        setIsPopupOpen(true);
    }
    const closePopup = () => {
        ////console.log("closePopup");
        resetAdminErrorFN();
        getUsersFN();
        setIsPopupOpen(false);
        setEditingUser(null);

    }

    useEffect(() => {
        resetAdminErrorFN();
        getUsersFN();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    useEffect(() => {

        if (edit_user_overlay) {
            resetEditUserOverlayFN();
            setEditingUser(edit_user_overlay);
            openpopup(true);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [edit_user_overlay]);


    const tabs = [
        {
            key: "users",
            label: "Users",
            icon: (
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeWidth="1.5" d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" strokeWidth="1.5" />
                    <path strokeWidth="1.5" d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
            ),
        },
        {
            key: "departments",
            label: "Departments",
            icon: (
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeWidth="1.5" d="M3 21V5a2 2 0 0 1 2-2h6l4 4v14H3z" />
                    <path strokeWidth="1.5" d="M11 3v4h4" />
                </svg>
            ),
        },
        {
            key: "levels", // keep your existing state key; label shows “Risk Assessment”
            label: "Risk Assessment",
            icon: (
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeWidth="1.5" d="M12 9v4m0 4h.01" />
                    <path strokeWidth="1.5" d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                </svg>
            ),
        },
    ];


    return token ? (
        <div className="flex flex-col w-full h-screen overflow-hidden">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
            <div className="flex flex-row w-full h-full overflow-hidden"> {/* Prevent horizontal scrolling */}
                <Sidebar className="fixed top-0 left-0 h-full pt-[64px] z-0" /> {/* Adjust the top to match TopBar height */}
                <div className="flex flex-col w-full p-4 overflow-auto"> {/* Adjust the margin-left to match Sidebar width */}
                    {currPage === "users" && (
                        <>
                            <div className="ml-8 mt-2">
                                <div
                                    className="inline-flex items-center bg-gray-100/80 rounded-full p-1 shadow-inner ring-1 ring-gray-200"
                                    role="tablist"
                                >
                                    {tabs.map((tab) => {
                                        const active = currPage === tab.key;
                                        return (
                                            <button
                                                key={tab.key}
                                                onClick={() => setcurrPage(tab.key)}
                                                role="tab"
                                                aria-selected={active}
                                                className={
                                                    "flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-full transition " +
                                                    (active
                                                        ? "bg-white text-gray-900 shadow"
                                                        : "text-gray-600 hover:text-gray-900")
                                                }
                                            >
                                                {tab.icon}
                                                <span>{tab.label}</span>
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>


                            <div className="h-full w-full mt-4">
                                <div className="flex flex-col gap-2">
                                    <AdminTable data={users} openpopup={openpopup} />
                                </div>
                            </div>
                        </>
                    )}

                    {currPage === "levels" && (
                        <>
                            <div className="ml-8 mt-2">
                                <div
                                    className="inline-flex items-center bg-gray-100/80 rounded-full p-1 shadow-inner ring-1 ring-gray-200"
                                    role="tablist"
                                >
                                    {tabs.map((tab) => {
                                        const active = currPage === tab.key;
                                        return (
                                            <button
                                                key={tab.key}
                                                onClick={() => setcurrPage(tab.key)}
                                                role="tab"
                                                aria-selected={active}
                                                className={
                                                    "flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-full transition " +
                                                    (active
                                                        ? "bg-white text-gray-900 shadow"
                                                        : "text-gray-600 hover:text-gray-900")
                                                }
                                            >
                                                {tab.icon}
                                                <span>{tab.label}</span>
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>

                            <RiskLevels></RiskLevels>

                        </>
                    )}
                    {currPage === "departments" && (
                        <>
                            <div className="ml-8 mt-2">
                                <div
                                    className="inline-flex items-center bg-gray-100/80 rounded-full p-1 shadow-inner ring-1 ring-gray-200"
                                    role="tablist"
                                >
                                    {tabs.map((tab) => {
                                        const active = currPage === tab.key;
                                        return (
                                            <button
                                                key={tab.key}
                                                onClick={() => setcurrPage(tab.key)}
                                                role="tab"
                                                aria-selected={active}
                                                className={
                                                    "flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-full transition " +
                                                    (active
                                                        ? "bg-white text-gray-900 shadow"
                                                        : "text-gray-600 hover:text-gray-900")
                                                }
                                            >
                                                {tab.icon}
                                                <span>{tab.label}</span>
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>

                            <Departments></Departments>
                        </>
                    )}

                </div>
            </div>





          <Popup
  open={isPopupOpen}
  onClose={closePopup}
  modal
  nested
  contentStyle={{
    padding: 0,
    border: "none",
    background: "transparent",
    boxShadow: "none",
    width: "auto",
    maxWidth: "none",
    overflow: "visible",
    marginTop: "14vh",
  }}
  overlayStyle={{
    background: "rgba(0,0,0,0)", // remove background tint
  }}
  className="no-popup-wrapper"
>
  <AdminOverlay
    departments={departments}
    created={created}
    resetAdminErrorFN={resetAdminErrorFN}
    error_message={error_message}
    closePopup={closePopup}
    mode={editinguser ? "edit" : "create"}
    user={users && editinguser ? users.find((user) => user.user_id === editinguser) : null}
    doit={editinguser ? updateUserFN : createUserFN}
  />
</Popup>




        </div>
    ) : <Redirect to="/login" />;

}

const mapStateToProps = (state) => {
    return {

        token: state.auth.token,
        users: state.admin.admin_users,
        edit_user_overlay: state.admin.edit_user_overlay,
        error_message: state.admin.error_message,
        created: state.admin.created,
        departments: state.department.departments,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        getUsersFN: () => dispatch(getUsers()),
        createUserFN: (user) => dispatch(createUser(user)),
        updateUserFN: (user) => dispatch(updateUser(user)),
        resetEditUserOverlayFN: () => dispatch(resetEditUserOverlay()),
        resetAdminErrorFN: () => dispatch(resetAdminError()),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Users);
